
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/learn/mfa-on-vpn",
      function () {
        return require("private-next-pages/learn/mfa-on-vpn.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/learn/mfa-on-vpn"])
      });
    }
  